export const DraftStatusBadge = ({
  product,
  onToggle,
  disabled,
}: {
  product?: any
  onToggle: () => void
  disabled?: boolean
}) => {
  const isPublished = product?.is_draft === false

  return (
    <span
      onClick={disabled ? undefined : onToggle}
      className={`inline-flex items-center gap-1 px-3 py-1 text-xs rounded-full font-medium ${
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      } ${
        isPublished
          ? 'bg-green-100 text-green-700'
          : 'bg-orange-100 text-orange-700'
      }`}
    >
      <span
        className={`h-2 w-2 rounded-full mr-1 ${
          isPublished ? 'bg-green-500' : 'bg-orange-500'
        }`}
      />
      {isPublished ? 'Published' : 'Not published'}
    </span>
  )
}

